<div
  aria-live="polite"
  aria-atomic="true"
  class="">
  <div class="toast-container position-fixed top-0 start-50 translate-middle-x mt-5">
    @for (toast of toastService.toasts; track $index) {
      <ngb-toast
        [autohide]="true"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)">
        @if (toast.icon) {
          <i class="pays-icon {{ toast.icon }} me-2"></i>
        }
        {{ toast.body }}</ngb-toast
      >
    }
  </div>
</div>
